import { Proposal } from 'types';

export const FUNNEL_STEPS = [
  'concern-type',
  'relationship',
  'place',
  'type',
  'character',
  'data',
] as const;

export type FunnelStep = (typeof FUNNEL_STEPS)[number];

export interface FunnelAdditionalData {
  skip?: boolean;
  skipIntro?: boolean;
  steps: FunnelStep[];
}

export interface FunnelTrackingData extends Partial<Proposal> {
  skipped_steps?: string[];
}

export type Trktype = 'impression' | 'click' | 'click,impression';
